import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SecurityWebapiService } from '../http/security/security-webapi.service';
import {
  DropdownItemOptions,
  DropdownOptions,
} from '@usitsdasdesign/dds-ng/dropdown';
import { DashboardConstant, dropdownOptions } from './dashboard.helper';
import { PositionState } from '@usitsdasdesign/dds-ng/shared';
import { DashboardRolesForOptions } from '../common/models/start-page/start-page.model';
import { CommonService } from '../http/intake/common.service';
import { AdobeAnalyticsService } from '../common/services/adobe-analytics.service';
import { WINDOW_SCROLL_SIZE } from '../app.constants';
import { RoleService } from '../http/intake/role.service';
import { takeUntil, Subject, take } from 'rxjs';
import { EntityDetails, EntityType } from '../http/user.service';
import { IntakeConstant } from '../intake/constants/intake.constant';
import { MatrixKeys } from '../common/constants/security-matrix';
import { RoleEnum } from '../intake/constants/Role.enum';
import { PermissionsObj } from '../common/models/common-models';
import { PermissionCheckService } from '../common/validations/permission-check.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.less'],
})
export class StartPageComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly unsubscribe$: Subject<void> = new Subject<void>();
  public Nca_Specialist: string = DashboardConstant.NCA_SPECIALIST;
  public Reviewer: string = DashboardConstant.REVIEWER;
  public Engagement_Team: string = DashboardConstant.ENGAGEMENT_TEAM;
  public Risk_Manager: string = DashboardConstant.RISK_MANAGER;

  selectedRole: string = '';
  roles: string[] = [];
  externalCommunication: string = 'External Communication';
  globalEngagements: string = 'Global Engagements';
  permissionObj: PermissionsObj = {} as PermissionsObj;

  dropdownOptions: DropdownOptions = dropdownOptions;
  dropdownItems: DropdownItemOptions[] = [
    {
      heading: 'Contract/Proposal/Eng. Related Review',
      value: 'Contract/Proposal/Eng. Related Review',
    },
    {
      heading: this.externalCommunication,
      value: this.externalCommunication,
    },
  ];
  dropdownStickerPosition: PositionState = PositionState.bottomLeft;

  public clientNumber: string = '';
  private securityNcaDashboard: string = 'ClientStatus.NcaDashboard';
  private isDashboardSecurity: boolean = false;
  private isReviewerPermission: boolean = false;
  private isRiskManagerPermission: boolean = false;
  private isEngagementPermission: boolean = false;
  private isPermissionsEmpty: boolean = true;

  dropdownWidth: string = '';
  loggedInUserRoles: string[] | undefined = undefined;

  // Mapping from API role names to DashboardRolesForOptions
  private readonly ROLE_DASHBOARD_MAP: { [key: string | RoleEnum]: string } = {
    [RoleEnum.REVIEWER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.EXT_COMM_REVIEWER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.RISK_MANAGER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.EXT_COMM_RISK_MANAGER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.ENGAGEMENT_TEAM_MEMBER]: DashboardRolesForOptions.EngagementTeam,
    [RoleEnum.EXT_COMM_ENGAGEMENT_TEAM_MEMBER]:
      DashboardRolesForOptions.EngagementTeam,
    'Sector leader': DashboardRolesForOptions.Reviewer,
    'QRM (Quality Risk Manager)': DashboardRolesForOptions.Reviewer,
    Approver: DashboardRolesForOptions.Reviewer,
    'Industry NCA Risk Manager': DashboardRolesForOptions.Reviewer,
    'Lead Business Partner': DashboardRolesForOptions.Reviewer,
    [RoleEnum.SPECIALIZED_OFFERING_RISK_LEADER]:
      DashboardRolesForOptions.Reviewer,
    [RoleEnum.RISK_MANAGER_READ_ONLY]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.MARS_QRM]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.RECOMMENDING_PPMD]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.MARS_INDUSTRY_LEADER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.EXT_COMM_SUPPORTING_RISK_MANAGER]:
      DashboardRolesForOptions.Reviewer,
    [RoleEnum.SUPPORTING_RISK_MANAGER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.SPECIALIZED_RISK_MANAGER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER]:
      DashboardRolesForOptions.Reviewer,
    [RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER_READ_ONLY]:
      DashboardRolesForOptions.Reviewer,
    [RoleEnum.DELIVERY_CENTER_RISK_MANAGER]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.RM_SUPPORT_GLOBAL]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.RM_SUPPORT_LOCAL]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.GLOBAL_RM_SUPPORT_GLOBAL]: DashboardRolesForOptions.Reviewer,
    [RoleEnum.NCA_MANAGER]: DashboardRolesForOptions.NCASpecialist,
    [RoleEnum.NCA_SPECIALIST]: DashboardRolesForOptions.NCASpecialist,
    [RoleEnum.ADDITIONAL_APPROVER]: DashboardRolesForOptions.Reviewer
    // Add more mappings as needed
  };

  constructor(
    private route: ActivatedRoute,
    private securityWebapiService: SecurityWebapiService,
    private readonly router: Router,
    private readonly commonService: CommonService,
    private analytics: AdobeAnalyticsService,
    private roleService: RoleService,
    private cdr: ChangeDetectorRef,
    private readonly permissionCheck: PermissionCheckService
  ) {}

  ngOnInit(): void {
    // Subscribe to route parameters if needed
    this.route.params.subscribe((params: Params) => {
      this.securityWebapiService.getPermissionsByEmployeeId(
        EntityDetails.None,
        EntityType.None
      ).then(() => {
              this.permissionCheck.updatePermissions();
              this.roleService.setPermissionObj(this.permissionObj);
            })
            .catch((error: HttpErrorResponse) => {
              console.error('Error fetching permissions:', error);
            });
    });

    // Subscribe to user roles from the RoleService
    this.roleService.currentUserRoleForDashboard$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response: string[]|undefined) => {
          if(response!=undefined){
            this.loggedInUserRoles = response;
            this.updateRoles();
          }
        },
        error: (error) => {
          console.error('Error fetching user roles:', error);
        },
      });

    // Subscribe to security API data to check NCA permissions
    this.securityWebapiService.data
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (rules) => {
          if (!rules.empty) {
            this.isDashboardSecurity =
              rules[this.securityNcaDashboard] &&
              rules[this.securityNcaDashboard].Visible;

            this.isReviewerPermission =
              rules[MatrixKeys.Intake_Dashboard_Reviewer]?.Visible ||
              rules[MatrixKeys.EXT_COM_Unassigned_ReviewerDashboard]?.Visible ||
              rules[MatrixKeys.EXT_COM_ReviewerDashboard]?.Visible ||
              rules[MatrixKeys.EXT_COM_AllSubmissions_ReviewerDashboard]
                ?.Visible ||
              rules[MatrixKeys.GLOBAL_ENG_ReviewerDashboard]?.Visible ||
              rules['ClientStatus.ReviewerDashboard']?.Visible;

            this.isRiskManagerPermission =
              rules[MatrixKeys.Intake_Dashboard_RiskManagerOversight]?.Visible;

            this.isEngagementPermission =
              rules[MatrixKeys.Intake_Dashboard_EngagementTeam]?.Visible ||
              rules[MatrixKeys.EXT_COM_EngagementTeamDashboard]?.Visible ||
              rules[MatrixKeys.GLOBAL_ENG_EngagementTeamDashboard]?.Visible;

            const isGlobalEngPermission =
              rules[MatrixKeys.GLOBAL_ENG_GearIcon_GlobalEngagements]?.Enable;

            const globalEngIndex = this.dropdownItems.findIndex(
              (item) => item.heading === this.globalEngagements
            );

            if (isGlobalEngPermission && globalEngIndex === -1) {
              this.dropdownItems.splice(2, 0, {
                heading: this.globalEngagements,
                value: this.globalEngagements,
              });
            } else if (!isGlobalEngPermission && globalEngIndex !== -1) {
              this.dropdownItems.splice(globalEngIndex, 1);
            }

            this.updateRoles();
          }
        },
        error: (error) => {
          console.error('Error fetching security rules:', error);
        },
      });
  }

  private updateRoles(): void {
    const updatedRoles = new Set<string>();

    if (this.loggedInUserRoles && this.loggedInUserRoles.length > 0) {
      this.loggedInUserRoles.forEach((role) => {
        if (role === 'System Administrator') {
          updatedRoles.add(DashboardRolesForOptions.NCASpecialist);
          updatedRoles.add(DashboardRolesForOptions.EngagementTeam);
          updatedRoles.add(DashboardRolesForOptions.RiskManager);
        } else {
          const dashboard = this.ROLE_DASHBOARD_MAP[role];
          if (dashboard) {
            updatedRoles.add(dashboard);
          } else {
            console.warn(`No dashboard mapping found for role: ${role}`);
          }
        }
      });

      if (this.isDashboardSecurity) {
        updatedRoles.add(DashboardRolesForOptions.NCASpecialist);
      }
      if (this.isReviewerPermission) {
        updatedRoles.add(DashboardRolesForOptions.Reviewer);
      }
      if (this.isRiskManagerPermission) {
        updatedRoles.add(DashboardRolesForOptions.RiskManager);
      }
      
      updatedRoles.add(DashboardRolesForOptions.EngagementTeam); //visisble for all roles

    } else if (
      this.loggedInUserRoles?.length === 0
    ) {
      updatedRoles.add(DashboardRolesForOptions.EngagementTeam);
    }

    this.roles = Array.from(updatedRoles);

    if (this.roles.length > 0) {
      if (localStorage.getItem('currentDashboard')) {
        this.selectedRole = localStorage.getItem('currentDashboard')!;
        localStorage.removeItem('currentDashboard')!;
      }
      else{
        this.selectedRole = this.roles[0];
      }
      this.analytics.trackPage(`${this.selectedRole} dashboard`);
      this.getRoleWidth();
    } else {
      this.selectedRole = IntakeConstant.EMPTY_SPACE;
    }
  }

  ngAfterViewInit(): void {
    this.getRoleWidth();
  }
  onRoleChange(event?: any): void {
    this.commonService.setSelectedDashboard(this.selectedRole);
    this.getRoleWidth();
    this.analytics.trackPage(`${this.selectedRole} dashboard`);
  }

  getRoleWidth(additionalWidth: number = 0) {
    this.dropdownWidth =
      this.selectedRole === DashboardRolesForOptions.Reviewer ||
      this.selectedRole === DashboardRolesForOptions.EngagementTeam
        ? `${this.selectedRole.length + 3 + additionalWidth}ch`
        : `${this.selectedRole.length + additionalWidth}ch`;
    this.cdr.detectChanges();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    if (window.scrollY > WINDOW_SCROLL_SIZE) {
      this.getRoleWidth(2);
    } else {
      this.getRoleWidth(0);
    }
  }

  initiateNewItemSelected(event: string): void {
    if (event === 'Contract/Proposal/Eng. Related Review') {
      this.router.navigate(['/submission']);
    } else if (event === this.globalEngagements) {
      this.router.navigate(['/globalEngagements/create']);
    } else if (event === this.externalCommunication) {
      this.router.navigate(['/externalCommunications/create']);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
